import { Component, Inject, NgModule } from '@angular/core';
import { SiteBrowserState } from '../../core/util/site-browser.state';
import { BreadcrumbModule } from 'primeng/components/breadcrumb/breadcrumb';
import { CommonModule } from '@angular/common';
/**
 * The BreadcrumbComponent provides a PrimeNG Component for providing navigation with dotCMS Components
 * It can respond to the Site or Folder being changed.  In addition the navigation it provides can be clicked on
 * There is no connection to the other components directly.  The interaction is all managed by the [[SiteBrowserState]]
 */
var BreadcrumbComponent = (function () {
    function BreadcrumbComponent(updateService) {
        var _this = this;
        this.updateService = updateService;
        this.buildMenuItemsFromURI(this.updateService.getURI());
        updateService.currentSite.subscribe(function (site) {
            _this.onSiteChange(site);
        });
        updateService.currentFolder.subscribe(function (folderName) {
            _this.onFolderClick(folderName);
        });
        updateService.currentURI.subscribe(function (uri) {
            _this.buildMenuItemsFromURI(uri);
        });
    }
    /**
     * Called when the [[SiteBrowserState]] Site is changed. This is managed via a Subscription
     * @param siteName
     */
    BreadcrumbComponent.prototype.onSiteChange = function (site) {
        this.pathItems = [];
        this.addSiteItem(site);
    };
    /**
     * Called when the [[SiteBrowserState]] Folder is changed. This is managed via a Subscription
     * @param folderName
     */
    BreadcrumbComponent.prototype.onFolderClick = function (folderName) {
        if (!folderName) {
            return;
        }
        var uri = this.getCurrentURI() + '/' + folderName;
        this.addFolderItem(folderName);
    };
    BreadcrumbComponent.prototype.getCurrentURI = function () {
        var uri = '';
        for (var i = 1; i < this.pathItems.length; i++) {
            var pi = this.pathItems[i];
            uri = uri + '/' + pi.label;
        }
        return uri;
    };
    BreadcrumbComponent.prototype.addSiteItem = function (site) {
        var _this = this;
        this.pathItems.push({
            command: function (event) {
                _this.updateService.changeSite(site);
                _this.updateService.changeURI(null);
                _this.updateService.changeFolder(null);
                setTimeout(function () {
                }, 100);
            }, label: site ? site.hostname : ''
        });
    };
    BreadcrumbComponent.prototype.addFolderItem = function (folderName) {
        var _this = this;
        var currentURI = this.getCurrentURI();
        this.pathItems.push({
            command: function (event) {
                _this.updateService.changeURI(currentURI + '/' + folderName);
                setTimeout(function () {
                }, 100);
            }, label: folderName
        });
    };
    BreadcrumbComponent.prototype.buildMenuItemsFromURI = function (uri) {
        this.pathItems = [];
        var site = this.updateService.getSelectedSite();
        if (!site || !site.hostname) {
            return;
        }
        this.addSiteItem(site);
        if (uri) {
            var folders = uri.split('/');
            for (var i = 0; i < folders.length; i++) {
                this.onFolderClick(folders[i]);
            }
        }
    };
    return BreadcrumbComponent;
}());
export { BreadcrumbComponent };
BreadcrumbComponent.decorators = [
    { type: Component, args: [{
                selector: 'breadcrumb',
                styles: [require('./../app.css')],
                template: "<p-breadcrumb [model]=\"pathItems\"></p-breadcrumb>"
            },] },
    { type: Inject, args: ['updateService',] },
];
/** @nocollapse */
BreadcrumbComponent.ctorParameters = function () { return [
    { type: SiteBrowserState, },
]; };
var DotBreadcrumbModule = (function () {
    function DotBreadcrumbModule() {
    }
    return DotBreadcrumbModule;
}());
export { DotBreadcrumbModule };
DotBreadcrumbModule.decorators = [
    { type: NgModule, args: [{
                declarations: [BreadcrumbComponent],
                exports: [BreadcrumbComponent],
                imports: [CommonModule, BreadcrumbModule],
                providers: []
            },] },
];
/** @nocollapse */
DotBreadcrumbModule.ctorParameters = function () { return []; };
//# sourceMappingURL=breadcrumb.component.js.map